import script from "./ModalSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSimple.vue?vue&type=script&setup=true&lang=js"

import "./ModalSimple.vue?vue&type=style&index=0&id=330b92d4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330b92d4"]])

export default __exports__